import { cn } from "@/lib/utils";

const DateSeparator = ({ date, className }) => {
  const formatDate = (timestamp) => {
    const messageDate = new Date(timestamp);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    // Reset time for comparison
    const messageDateOnly = new Date(messageDate.getFullYear(), messageDate.getMonth(), messageDate.getDate());
    const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const yesterdayOnly = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());

    if (messageDateOnly.getTime() === todayOnly.getTime()) {
      return "Hôm nay";
    } else if (messageDateOnly.getTime() === yesterdayOnly.getTime()) {
      return "Hôm qua";
    } else {
      return messageDate.toLocaleDateString("vi-VN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    }
  };

  return (
    <div className={cn("flex items-center justify-center my-4", className)}>
      <div className="flex-grow border-t border-gray-300"></div>
      <div className="mx-4 text-xs text-gray-500 bg-white px-2 py-1 rounded-full border border-gray-200">{formatDate(date)}</div>
      <div className="flex-grow border-t border-gray-300"></div>
    </div>
  );
};

export default DateSeparator;
